const runMethods = (methods, delayMs = 100) => {
  methods.forEach((method, index) => {
    window.setTimeout(() => {
      try {
        method();
      } catch {
        /* try the next kiosk bridge */
      }
    }, index * delayMs);
  });
};

export function closeApp() {
  const win = window;
  const nav = window.navigator;
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    navigator.standalone === true;
  const isWindows = /Windows/i.test(navigator.userAgent);

  if (isAndroid) {
    runMethods([
      () => win.Android?.finish?.(),
      () => win.Android?.finishAffinity?.(),
      () => win.Android?.exitApp?.(),
      () => win.Android?.finishAndRemoveTask?.(),
      () => win.Android?.moveTaskToBack?.(true),
      () => win.Android?.closeApp?.(),
      () => nav.app?.exitApp?.(),
      () => win.kioskAPI?.close?.(),
      () => win.kioskAPI?.systemExit?.(),
    ]);
    return;
  }

  if (isStandalone || isWindows) {
    runMethods([
      () => window.close(),
      () => nav.app?.exitApp?.(),
      () => win.electronAPI?.close?.(),
      () => {
        window.location.href = 'about:blank';
      },
      () => window.location.replace('about:blank'),
    ]);
    return;
  }

  runMethods(
    [
      () => window.close(),
      () => nav.app?.exitApp?.(),
      () => {
        window.location.href = 'about:blank';
      },
      () => window.location.replace('about:blank'),
    ],
    500
  );
}

export const pinsMatch = (entered, expected) =>
  String(entered || '').trim() === String(expected || '').trim();
